<template>
    <!-- <section class="card log-panel col-md-4 offset-md-4 col-10 offset-1 mt-md-0 mt-1">
        
    </section> -->
    <ProfileForm />
</template>
<script>
import GeneralModal from "@/components/Modal.vue";
import AlertModal from "@/components/AlertModal.vue";
import ProfileForm from "@/components/Profile/ProfileForm.vue";
export default {
    name: "profile",
    components: {
        GeneralModal,
        AlertModal,
        ProfileForm,
    },
    // data() {
    //     return {
            
    //     }
    // },
    // created(){
    //     this.fetchOptions()
    // },
    // methods: {
        
        
    //     /*****************************/
    // }
}
</script>
<style>

</style>